<template>
  <div class="pagination">
    <!-- Previous Link -->
    <router-link v-if="previousLink" :to="'/' + previousLink">
      <i class="fas fa-angle-double-left"></i><span id="previousLinkActive">Previous</span>
    </router-link>
    <span class="disabled" v-else
      ><i class="fas fa-angle-double-left"></i><span id="previousLinkDisabled">Previous</span>
    </span>

    <!-- Before Links -->
    <router-link 
      v-for="link in beforeLinks"
      :key="link"
      :to="'/' + link"
    >
      {{ link }}
    </router-link>

    <!-- Current Link -->
    <span class="currentPage">{{ currentPage }}</span>


    <!-- After Links -->
    <router-link 
      v-for="link in afterLinks"
      :key="link"
      :to="'/' + link"
    >
      {{ link }}
    </router-link>


    <!-- Next Link -->
    <router-link v-if="nextLink" :to="'/' + nextLink">
        <span id="nextLinkActive">Next</span> <i class="fas fa-angle-double-right"></i>
    </router-link>
    <span class="disabled" v-else>
        <span id="nextLinkDisabled">Next</span><i class="fas fa-angle-double-right"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Number,
      default: 1,
    },
    pageQuantity: Number,
  },
  data() {
    return {
      maxPages: 8,
    };
  },
  computed: {
    currentPage() {
      return parseInt(this.page)
    },
    previousLink() {
      return this.page != 1 ? this.currentPage - 1 : null;
    },
    nextLink() {
      return this.page != this.pageQuantity ? this.currentPage + 1 : null;
    },
    beforeLinks() {
      let links = [],
          pagesBefore = this.maxPages / 2 + 1

      for (let x = 1; x < pagesBefore; x++) {
        let link = this.currentPage - x
        
        if (link > 0) links.push(link)
      }

      return links.reverse()
    },
    afterLinks() {
      let links = [],
          pagesAfter = this.maxPages - this.beforeLinks.length

      for (let x = 1; x < pagesAfter; x++) {
        let link = this.currentPage + x
        
        if (link <= this.pageQuantity) links.push(link)
      }

      return links
    }
  },
};
</script>

<style lang="scss" scoped>
    /* Add styles from http://www.seattle.gov/searchresults?terms=seattle */
    .pagination {
        padding: 0 10px;
        margin: 54px 0 0 10px;
        float: left;
        width: 95%;
        text-align: center;
        font-size: 14px;
        font-weight: normal;

        .currentPage {
            color: #fff;
            background-color: #003da5;
            pointer-events: none;
            padding: 3px 9px;
        }

        .disabled {
            padding: 0 10px 0 10px;

            .svg-inline--fa, #previousLinkDisabled, #nextLinkDisabled {
                color: #ccc;
            }
        }

        a {
            display: inline-table;
            padding: 3px 9px;
            margin: 0 2px;
            color: #000;

            &:hover {
                background-color: #000;
                color: #fff;
            }

            &:link {
                text-decoration: none;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .pagination {
            padding: 0;
            width: 100%;
            margin: 14px 0 0 0;

            a {
                margin: 0 -1px;
            }

            #previousLinkActive,
            #previousLinkDisabled,
            #nextLinkActive,
            #nextLinkDisabled {
                display: none;
            }
        }
    }
</style>
